import styled from 'styled-components';
import { Body3Regular, Title2SemiBold } from 'styles/Global/typography';

interface ResultPageTitleProps {
    title?: string;
    description?: string;
}

export default function ResultPageTitle({ title, description }: ResultPageTitleProps) {
    return (
        <TitleContainer>
            <Title2SemiBold>{title ?? '결과 생성 완료!'}</Title2SemiBold>
            {description && <Body3Regular>{description}</Body3Regular>}
        </TitleContainer>
    );
}

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
`;
